<div class="col-12 m-0 p-0 d-flex">
    <div class="col-12 col-lg-7 px-0 position-relative" id="container-image">
        @if (selectedImage) {
            <img
                class="background-image"
                [class.center]="centerBackgroundImages"
                [ngSrc]="selectedImage"
                fill
                [alt]="alt"
                priority
            />
        }
        <div
            class="half-container w-100 h-100"
            [ngClass]="{ shadow: shadow, center: centerBackgroundImages }"
            id="search-image"
        >
            <ng-content select="[image-contain]" />
        </div>
    </div>
    <div class="col-12 col-lg-5 px-0 position-relative" [style.background-color]="backgroundColor">
        <ng-content select="[contain]" />
    </div>
</div>
